<app-map [customZoom]="15" [coordinates]="coordinates" (isFullscreenEvent)="changeFullscreen($event)" [shouldRecalculate]="shouldRecalculate$"></app-map>
<!-- <button mat-icon-button class="fullscreen">
	<mat-icon>{{ (isFullScreen$ | async) === true ? 'fullscreen' : 'fullscreen_exit' }}</mat-icon>
</button> -->

<button mat-raised-button class="close" (click)="onCloseClick()">
	<mat-icon>close</mat-icon>
</button>
